import { useState } from 'react'
import { Col } from 'components/ui/Col'
import { Row } from 'components/ui/Row'
import { UIButton } from 'components/ui/Button'
import { useTranslation } from 'react-i18next'
import { useModal } from 'providers/ModalProvider'
import { useCreateBlock } from 'api/blocks'
import { useFormik } from 'formik'
import { createValidationSchema, required } from 'utils/validations'
import { showSuccessToast } from 'utils/toast'
import { formFieldProps } from 'utils/form'
import { Input } from 'components/ui/Input'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

type Props = {
  areaId?: string
  userId?: string
}

export const CreateBlockModal = ({ userId, areaId }: Props) => {
  const { t } = useTranslation()
  const [loading, setLoading] = useState(false)
  const { mutateAsync: createBlock } = useCreateBlock({ userId, areaId })
  const { close } = useModal()

  const { values, errors, setFieldValue, setFieldError, handleSubmit } = useFormik({
    initialValues: {
      title: '',
    },
    validationSchema: createValidationSchema({
      title: required,
    }),
    validateOnBlur: false,
    validateOnChange: false,
    onSubmit: async (values) => {
      console.debug({ values })
      try {
        setLoading(true)
        await createBlock(values.title)
        showSuccessToast(t('notes.createdSuccess'))
        close()
      } finally {
        setLoading(false)
      }
    },
  })

  const fieldProps = formFieldProps(errors, values, setFieldError, setFieldValue)

  return (
    <Col className={'tw-shadow-md tw-rounded-lg tw-w-96 tw-primary-500 tw-p-4'}>
      <Row justifyContent={'space-between'} width={'100%'}>
        <div className={'tw-font-[800]'}>{t('notes.create')}</div>
        <div className={'tw-cursor-pointer'}>
          <FontAwesomeIcon icon={['far', 'times']} onClick={close} />
        </div>
      </Row>
      <Row justifyContent={'flex-start'} width={'100%'}>
        {t('notes.createMessage')}
      </Row>
      <Col width={'100%'} className={'tw-mt-2'}>
        <Input
          className={'tw-w-full'}
          label={t('notes.title')}
          {...fieldProps('title')}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              handleSubmit()
            }
          }}
        />
      </Col>
      <Row className={'tw-mt-4 tw-gap-2'} width={'100%'}>
        <UIButton className={'tw-w-full'} onClick={() => handleSubmit()} loading={loading}>
          <span className={'tw-text-sm'}>{t('confirm')}</span>
        </UIButton>
      </Row>
    </Col>
  )
}
